import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';

export interface DocumentsExistResponse {
  hasDocumentsAndFields: boolean;
}

@Injectable({
  providedIn: 'root',
})
export class DocumentsExistService {
  private readonly http = inject(HttpClient);

  getDocumentsExist(signingId: string): Observable<DocumentsExistResponse> {
    return this.http.get<DocumentsExistResponse>(
      `/api/v1/signings/${signingId}/documents/exists`,
    );
  }
}
